import {
  type ThemeOptions,
  type ComponentsProps,
  type ComponentsOverrides,
  type ComponentsVariants
} from '@mui/material/styles';
import type { Theme } from '@ui/ThemeRegistry/theme.types';

const defaultProps: ComponentsProps['FormNewsletter'] = {};

const styleOverrides: ComponentsOverrides<Theme>['FormNewsletter'] = {
  root: ({ theme, ownerState }) => ({
    backgroundColor: `var(--mui-palette-schemes-${ownerState?.backgroundColor}-primary-main)`
  }),

  mainContentWrap: ({ theme, ownerState }) => ({}),

  formEl: ({ theme, ownerState }) => ({
    gridColumnStart: 'full-start',
    gridColumnEnd: 'full-end'
  }),

  formGrid: ({ theme, ownerState }) => ({
    display: 'grid',
    gridColumnStart: 'full-start',
    gridColumnEnd: 'full-end',
    gridGap: 'var(--grid-gap)'
  }),

  email: ({ theme, ownerState }) => ({
    gridColumnStart: 'start',
    gridColumnEnd: 'end',
    gridRow: 1
  }),

  firstName: ({ theme, ownerState }) => ({
    gridColumnStart: 'start',
    gridColumnEnd: 'half',
    gridRow: 2
  }),

  lastName: ({ theme, ownerState }) => ({
    gridColumnStart: 'half',
    gridColumnEnd: 'end',
    gridRow: 2
  }),

  submitButtonWrap: ({ theme, ownerState }) => ({
    gridColumnStart: 'start',
    gridColumnEnd: 'end',
    gridRow: 3,
    display: 'flex',
    flexDirection: 'column',
    gap: 'var(--grid-gap-half)'
  }),

  contentOuterGrid: ({ theme }) => ({
    'margin': 'var(--grid-gap) 0',
    'rowGap': 'var(--grid-gap)',

    '> *': {
      gridColumnStart: 'auto'
    }
  })
};

const createVariants = (_theme: Theme): ComponentsVariants['FormNewsletter'] => [];

export const formNewsletterTheme = (theme: Theme): ThemeOptions => ({
  components: {
    FormNewsletter: {
      defaultProps,
      styleOverrides,
      variants: createVariants(theme)
    }
  }
});

export default formNewsletterTheme;
